import React from 'react';
import { List, Datagrid, ReferenceField, TextField, DateField, DeleteButton } from 'react-admin';

const CommentList = props => (
  <List {...props} bulkActionButtons={false}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="content" />
      <ReferenceField label="User" source="user_id" reference="users" linkType="show">
        <TextField source="full_name" />
      </ReferenceField>
      <ReferenceField label="Exercise" source="exercise_id" reference="exercises" linkType="show">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="reports" />
      <DateField source="created_at" showTime />
      <DeleteButton />
    </Datagrid>
  </List>
);

export default CommentList;



// WEBPACK FOOTER //
// ./src/resources/comments/CommentList.jsx